import { Button } from "@/components/ui/button";
import { CheckCircledIcon } from "@radix-ui/react-icons";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

export function BloctelSuccessPage() {
    useEffect(() => {
        document.title = `Bloctel | Walter CRM`;
    }, []);

    return (
        <>
            <div className="container mx-auto px-4 py-5 lg:px-5 lg:py-10">
                <div className="mx-auto mt-10 max-w-[500px] rounded border p-5">
                    <h1 className="mb-3 scroll-m-20 text-3xl font-bold tracking-tight lg:text-4xl">Passage en Bloctel</h1>
                    <div className="mx-auto mt-5 flex max-w-[750px] items-center justify-center">
                        <div className="p-5">
                            <CheckCircledIcon className="h-10 w-10 text-green-500" />
                        </div>
                        <p>Votre demande a bien été enregistrée et est en cours de traitement.</p>
                    </div>
                    <div className="mt-5 text-center">
                        <NavLink to="/outils/bloctel">
                            <Button size="lg" variant="outline">
                                Nouveau bloctel
                            </Button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
}
